import { Fragment } from "react"

const Syslog = props => {
  return <Fragment>Bitácora</Fragment>
}

export default Syslog
